'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _StringColumn2 = require('linksoft/data-tables/renderers/StringColumn');

var _StringColumn3 = _interopRequireDefault(_StringColumn2);

var _odataUri = require('linksoft/utils/odata-uri');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SimpleLookupColumn = function (_StringColumn) {
    _inherits(SimpleLookupColumn, _StringColumn);

    function SimpleLookupColumn() {
        _classCallCheck(this, SimpleLookupColumn);

        return _possibleConstructorReturn(this, (SimpleLookupColumn.__proto__ || Object.getPrototypeOf(SimpleLookupColumn)).apply(this, arguments));
    }

    _createClass(SimpleLookupColumn, [{
        key: 'displayValue',
        value: function displayValue(value) {
            var _this2 = this;

            var output = this.isArray ? (value || []).map(function (v) {
                return _this2.getLookupName(v);
            }).join(', ') : this.getLookupName(value);
            return output || _StringColumn2.noValue;
        }
    }, {
        key: 'getLookupName',
        value: function getLookupName(value) {
            return value && value.name || value;
        }
    }, {
        key: 'buildFilterExpression',
        value: function buildFilterExpression(fieldName, columnFilter) {
            return this.options.isArray ? _odataUri.filters.anyContains(fieldName, columnFilter, 'name') : _odataUri.filters.contains(fieldName, columnFilter, 'name');
        }
    }, {
        key: 'isArray',
        get: function get() {
            return !!this.options.isArray;
        }
    }, {
        key: 'orderByProp',
        get: function get() {
            return this.sourceProp + '.name';
        }
    }]);

    return SimpleLookupColumn;
}(_StringColumn3.default);

exports.default = SimpleLookupColumn;


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/datatables/SimpleLookupColumn.js
// module id = 426
// module chunks = 0